import { useQueryClient } from 'shared-ui';
import { toast } from 'react-toastify';

import { deleteControl } from 'api/control/control';
import { QueryKeyEnum } from 'core/global.enum';
import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { useMutation } from 'hooks/useMutation/useMutation';
import { useModalState } from 'hooks/useModalState/useModalState';

import { DeleteInstantControl } from './DeleteInstantControl';
import { DeleteInstantControlContainerProps } from './DeleteInstantControl.types';

export const DeleteRandomControlContainer = ({ owner }: DeleteInstantControlContainerProps) => {
  const queryClient = useQueryClient();
  const { formatMessage } = useLocale();
  const { isModalOpen, onModalOpen, onModalClose } = useModalState();

  const { mutate: onDeleteRandomControl, isLoading } = useMutation(deleteControl, {
    onSuccess: () => {
      queryClient.invalidateQueries([QueryKeyEnum.INSTANT_CONTROL_OWNERS]);
      queryClient.invalidateQueries([QueryKeyEnum.OWNERS_SEARCH]);
      toast.dark(formatMessage({ id: AppMessages['control.instant.deleteOwner.successMessage'] }));
      onModalClose();
    },
  });

  const onSubmit = () => {
    onDeleteRandomControl(owner.id);
  };

  return (
    <DeleteInstantControl
      isModalOpen={isModalOpen}
      onModalClose={onModalClose}
      onModalOpen={onModalOpen}
      isLoading={isLoading}
      onSubmit={onSubmit}
    />
  );
};
